import ascending from "./ascending.js";
import permute from "./permute.js";
export default function sort(values) {
    var F = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        F[_i - 1] = arguments[_i];
    }
    if (typeof values[Symbol.iterator] !== "function")
        throw new TypeError("values is not iterable");
    values = Array.from(values);
    var f = F[0];
    if ((f && f.length !== 2) || F.length > 1) {
        var index = Uint32Array.from(values, function (d, i) { return i; });
        if (F.length > 1) {
            F = F.map(function (f) { return values.map(f); });
            index.sort(function (i, j) {
                for (var _i = 0, F_1 = F; _i < F_1.length; _i++) {
                    var f_1 = F_1[_i];
                    var c = ascendingDefined(f_1[i], f_1[j]);
                    if (c)
                        return c;
                }
            });
        }
        else {
            f = values.map(f);
            index.sort(function (i, j) { return ascendingDefined(f[i], f[j]); });
        }
        return permute(values, index);
    }
    return values.sort(compareDefined(f));
}
export function compareDefined(compare) {
    if (compare === void 0) { compare = ascending; }
    if (compare === ascending)
        return ascendingDefined;
    if (typeof compare !== "function")
        throw new TypeError("compare is not a function");
    return function (a, b) {
        var x = compare(a, b);
        if (x || x === 0)
            return x;
        return (compare(b, b) === 0) - (compare(a, a) === 0);
    };
}
export function ascendingDefined(a, b) {
    return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}
